/**
 * Typy autentykacji
 * 
 * W tej aplikacji domyślnie używamy autoryzacji JWT.
 * 
 * name - 
 * type - typ tokena, wysylany w naglowku autorization
 * displayName - wyswietalna nazwa na stronie home
 * isDefault - okresla czy jest to typ domyslny. JWT jest typem domyslnym po tronie serwera, wiec jesli wybrany jest ten tym nie ma potrzeby go wysylac na serwer. 
 * 
 * Typ domyślny mozna przestawic przy starcie apliakcji metoda @function {setAuthorizationType}
 *  
 */
export const AuthenticationType = {
    //Autoryzacja za pomocą tokena JWT. 
    //Pierwszy krok to autoryzacja do serwera za pomocą login/hasło w celu uzyskania tokena JWT, który umieszczamy w każdym następnym zapytaniu w nagłówku Authorization
    JWT: { name: 'JWT', type: 'Bearer', displayName: 'Token autoryzacyjny czasowy', isDefault: true },
    //Autyoryzajca za pomocą tokena HMAC
    HMAC: { name: 'HMAC', type: 'f24v1-hmac-sha256', displayName: 'Hash-based Message Authentication Code', isDefault: false },
    //Autoryzacja za pomocą danych uwierzytelniających login:hasło zakodowanych base64
    BASIC: { name: 'BASIC', type: 'Basic', displayName: 'Token autoryzacyjny podstawowy', isDefault: false }
}

/**
 * Domyślny typ autoryzacji - mozna go zmeinic przy starcie aplikacji
 */
let defaultAuthenticationType = Object.values(AuthenticationType).find((type=> type.isDefault === true));

/**
 * Zwraca ustawiony typ autoryzacji
 */
export const getAuthenticationType = () => {
    return defaultAuthenticationType;
}

/**
 * Ustawia typ autentykacji
 * 
 * @param {AuthenticationType} authorizationType 
 */
export const setAuthenticationType = (authenticationType) => {
    defaultAuthenticationType = authenticationType;
}